import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { teamInitials } from '../../data/mockData';
import { EASE_OUT } from '../../utils/motion';
import { AppSidebar } from './AppSidebar';
const toneClasses = ['bg-cyan', 'bg-[#A78BFA]', 'bg-[#F5A524]', 'bg-[#34D399]'];
const inProgress = [72, 45];
export function PlannerMock() {
  const {
    t
  } = useLanguage();
  const p = t.ui.planner;
  return <div className="flex text-left md:min-h-[460px]" aria-hidden="true" data-id="element-63" data-mp="17nygqgaouob9">
      <AppSidebar active={1} data-id="element-64" data-mp="17lvhr6rk5kue" />
      <div className="min-w-0 flex-1 p-4 md:p-6" data-id="element-65" data-mp="1cmsz5h4quauu">
        <div className="mb-5 flex items-center justify-between" data-id="element-66" data-mp="1clzymxwdohl5">
          <div data-id="element-67" data-mp="1hf2w3h4a0b6m">
            <div className="text-[15px] font-semibold text-white md:text-lg" data-id="element-68" data-mp="1hfm528by7p8i">
              {p.title}
            </div>
            <div className="text-[11px] text-white/45 md:text-xs" data-id="element-69" data-mp="jwjbaenm7qvs">{p.week}</div>
          </div>
          <div className="flex items-center gap-4" data-id="element-70" data-mp="ovnkv6egbqmn">
            <span className="hidden items-center gap-1.5 text-[11px] text-white/50 sm:flex" data-id="element-71" data-mp="7o25yqs23esi">
              <span className="relative flex h-1.5 w-1.5" data-id="element-72" data-mp="2o7h0srucza3">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-cyan opacity-60" data-id="element-73" data-mp="2r1xyabnc1yr" />
                <span className="relative h-1.5 w-1.5 rounded-full bg-cyan" data-id="element-74" data-mp="3q1ru3ng4932x" />
              </span>
              {p.synced}
            </span>
            <div className="flex -space-x-1.5" data-id="element-75" data-mp="3l3qexdlt9nwq">
              {teamInitials.map(initials => <span key={initials} className="grid h-6 w-6 place-items-center rounded-full border border-surface bg-surface2 text-[9px] font-medium text-white/70" data-id="element-76" data-mp="3g2klfdkbtwm5">
                  {initials}
                </span>)}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-77" data-mp="19b1tjln1aqec">
          {p.columns.map((col, ci) => <div key={col.name} className={`rounded-lg bg-white/[0.03] p-2.5 ${ci > 1 ? 'hidden lg:block' : ''}`} data-id="element-78" data-mp="159q178crzr2g" data-mpi={ci}>
              <div className="mb-2.5 flex justify-between px-1 text-[11px] text-white/55" data-id="element-79" data-mp="33m1j3up8344i">
                <span data-id="element-80" data-mp="2pumrizh91ulu">{col.name}</span>
                <span data-id="element-81" data-mp="2prifjfxjlukm">{col.tasks.length}</span>
              </div>
              <div className="space-y-2" data-id="element-82" data-mp="2tw87wuszsr0s">
                {col.tasks.map((task, ti) => <div key={task.title} className="rounded-md border border-white/[0.06] bg-surface2 p-2.5" data-id="element-83" data-mp="3hlu8nmp0jeaw" data-mpi={ti}>
                    <div className="mb-2 flex items-center gap-1.5" data-id="element-84" data-mp="38kcvod6wjsqf">
                      <span className={`h-1.5 w-1.5 rounded-full ${toneClasses[task.tone]}`} data-id="element-85" data-mp="38m77n2074aid" />
                      <span className="text-[10px] text-white/45" data-id="element-86" data-mp="3dhcty1xifr6z">{task.tag}</span>
                    </div>
                    <div className={`text-[12px] leading-snug ${ci === 3 ? 'text-white/45' : 'text-white/90'}`} data-id="element-87" data-mp="1x70l7jgn0bva">
                      {task.title}
                    </div>
                    {ci === 1 && <div className="mt-2.5 h-1 overflow-hidden rounded-full bg-white/[0.06]" data-id="element-88" data-mp="1pkdc6pquqi2h">
                        <motion.div className="h-full rounded-full bg-cyan" initial={{
                  width: 0
                }} whileInView={{
                  width: `${inProgress[ti]}%`
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.3,
                  delay: 0.3 + ti * 0.06,
                  ease: EASE_OUT
                }} data-id="element-89" data-mp="23k4w1741usoe" />
                      </div>}
                    <div className="mt-2 flex items-center justify-between text-[10px] text-white/40" data-id="element-90" data-mp="1koepr7p33a4p">
                      <span data-id="element-91" data-mp="1ftsfx8ynhpmq">{task.date}</span>
                      {ci === 3 && <CheckIcon className="h-3 w-3 text-cyan" data-id="element-92" data-mp="s4q086nku6uv" />}
                    </div>
                  </div>)}
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}